import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const AstroAppointments = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  const [appointment, setAppointment] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const hasSlotReservation = Boolean(appointment?.SlotId);

const formatDate = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /^(\d{4})-(\d{2})-(\d{2})/
    );

    if (match) {
      const [, year, month, day] = match;
      return `${day}-${month}-${year}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const day = String(value.getDate()).padStart(2, "0");
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const year = value.getFullYear();

    return `${day}-${month}-${year}`;
  }

  return "-";
};

const formatTime = (value) => {
  if (!value) return "-";

  // MySQL DATETIME: YYYY-MM-DD HH:MM:SS
  // Also supports: YYYY-MM-DDTHH:MM:SS
  if (typeof value === "string") {
    const match = value.match(
      /[ T](\d{2}):(\d{2})/
    );

    if (match) {
      const [, hour, minute] = match;
      return `${hour}:${minute}`;
    }
  }

  // Handles JavaScript Date objects returned by mysql2
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const hour = String(value.getHours()).padStart(2, "0");
    const minute = String(value.getMinutes()).padStart(2, "0");

    return `${hour}:${minute}`;
  }

  return "-";
};

  useEffect(() => {
    if (!bookingId) return;

    Promise.all([
      axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}`),
      axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}/category-data`)
    ])
      .then(([aRes, cRes]) => {
        setAppointment(aRes.data || null);
        setCategoryData(cRes.data || null);
      })
      .catch(() => {
        setAppointment(null);
        setCategoryData(null);
      })
      .finally(() => setLoading(false));
  }, [bookingId]);



  const label = {
  padding: "8px 6px",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  verticalAlign: "top",
  width: "40%"
};

const value = {
  padding: "8px 6px",
  fontSize: 13,
  color: "#111827",
  verticalAlign: "top"
};

const isSelfBooking =
  categoryData?.data?.booking_type?.toLowerCase() === "self";

const changeStatus = async (newStatus) => {
  if (!window.confirm(`Mark this appointment as ${newStatus}?`)) {
    return;
  }

  try {
    const response = await axios.post(
      `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}/status`,
      {
        status: newStatus
      }
    );

    /*
     * When appointment is marked Completed,
     * the backend automatically sends the feedback email
     * to appointment.UserEmail.
     */
    if (newStatus.toLowerCase() === "completed") {

      if (response.data.feedbackEmailSent) {

        alert(
          "Appointment marked as completed. Feedback email has been sent to the customer."
        );

      } else {

        alert(
          "Appointment marked as completed. Customer feedback email could not be sent because no email address was available."
        );

      }

      /*
       * Take the astrologer away from the completed
       * appointment page so the button cannot be clicked
       * again accidentally.
       */
      navigate("/astrologerdashboard");

      return;
    }

    /*
     * For any other status update.
     */
    alert(`Status updated to ${newStatus}`);

    // Update UI locally
    setAppointment((prev) => ({
      ...prev,
      Status: newStatus
    }));

  } catch (err) {

    console.error(
      "Error updating status:",
      err
    );

    alert(
      "Failed to update status."
    );
  }
};

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: 40 }}>Loading appointment…</p>;
  }

  if (!appointment) {
    return <p style={{ textAlign: "center", marginTop: 40 }}>Appointment not found.</p>;
  }

  return (
    <>
      <Helmet>
        <title>eConsultation Appointment Details | Adhigyanam</title>
      </Helmet>

    <div
  style={{
    maxWidth: 900,
    margin: "20px auto",
    padding: "12px 18px",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    color: "#475569",
    flexWrap: "wrap"
  }}
>
  {/* Home */}
  <a
    href="/"
    style={{
      color: "#2563eb",
      fontWeight: 600,
      textDecoration: "none"
    }}
  >
    Home
  </a>

  <span style={{ color: "#94a3b8" }}>›</span>

  {/* Astrologer Dashboard */}
  <a
    href="/astrologerdashboard"
    style={{
      color: "#2563eb",
      fontWeight: 600,
      textDecoration: "none"
    }}
  >
    Dashboard
  </a>

  <span style={{ color: "#94a3b8" }}>›</span>

  {/* Current Page */}
  <span
    style={{
      fontWeight: 700,
      color: "#0f172a"
    }}
  >
    Appointment Details
  </span>
</div>

      <section style={{ padding: "30px 0", paddingTop:"0px" }}>
        <div
          style={{
            maxWidth: 900,
            margin: "auto",
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: 24
          }}
        >
          {/* HEADER */}
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ fontSize: 18, fontWeight: 700 }}>
              Booking ID: #{appointment.Id}
            </h4>
            <p style={{ fontSize: 13, color: "#6b7280" }}>
              Booked on {formatDate(appointment.BookingDate)}
            </p>
          </div>

          {/* STATUS */}
          <div style={{ marginBottom: 20 }}>
            <b>Status:</b>{" "}
            <span
              style={{
                fontWeight: 700,
                color:
                  appointment.Status === "Completed"
                    ? "#15803d"
                    : appointment.Status === "Pending"
                    ? "#b45309"
                    : "#374151"
              }}
            >
              {appointment.Status}
            </span>
          </div>

          {/* SUMMARY */}
          <table style={{ width: "100%", fontSize: 13 }}>
            <tbody>
              <tr>
                <td><b>Category</b></td>
                <td>{appointment.Category}</td>
              </tr>
              <tr>
                <td><b>Session Date</b></td>
                <td>{formatDate(appointment.start_datetime)}</td>
              </tr>
              <tr>
                <td><b>Start Time</b></td>
                <td>{formatTime(appointment.start_datetime)} IST</td>
              </tr>
              <tr>
                <td><b>Slot Duration</b></td>
                <td>{appointment.total_time} minutes</td>
              </tr>
              
            </tbody>
          </table>

          {hasSlotReservation && (
  <div style={{ marginTop: 25 }}>
    <p
      style={{
        fontWeight: 700,
        fontSize: 14,
        marginBottom: 10,
        color: "#0f172a",
        textDecoration: "underline"
      }}
    >
      Appointment Schedule
    </p>

    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <tbody>
        <tr>
          <td style={{ fontWeight: 600 }}>
            Slot Starts:
            {" "}
            {formatDate(appointment.start_datetime)}{" "}
            {formatTime(appointment.start_datetime)} IST<br/>

             Slot Ends:
            {" "}
            {formatDate(appointment.end_datetime)}{" "}
            {formatTime(appointment.end_datetime)} IST
          </td>

          <td style={{ fontWeight: 600 }}>
           
          </td>

          <td style={{ fontWeight: 600 }}>
          Consultation Duration:
            {" "}
            {appointment.user_time
              ? `${appointment.user_time} mins`
              : "-"}<br/>

            Total Slot Duration:
            {" "}
            {appointment.total_time
              ? `${appointment.total_time} mins`
              : "-"}<br/>(Consultation + Buffer + Cooling Period)
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)}

{hasSlotReservation && (
  <div
    style={{
      marginTop: 15,
      border: "1px solid #e5e7eb",
      borderRadius: 8,
      overflow: "hidden"
    }}
  >
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ background: "#f9fafb" }}>
          {["Consultation Starts", "Consultation Ends", "User Time", "Buffer Time", "Cooling Time" ].map((h) => (
            <th
              key={h}
              style={{
                padding: "8px",
                fontSize: 12,
                fontWeight: 700,
                textAlign: "left",
                borderBottom: "1px solid #e5e7eb"
              }}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td style={{ padding: "8px", fontSize: 12 }}>
            {appointment.display_start || "-"}
          </td>
           <td style={{ padding: "8px", fontSize: 12 }}>
            {appointment.display_end || "-"}
          </td>
          <td style={{ padding: "8px", fontSize: 12 }}>
            {appointment.user_time
              ? `${appointment.user_time}m`
              : "-"}
          </td>
          <td style={{ padding: "8px", fontSize: 12 }}>
            {appointment.buffer_time
              ? `${appointment.buffer_time}m`
              : "-"}
          </td>
          <td style={{ padding: "8px", fontSize: 12 }}>
            {appointment.cooling_time
              ? `${appointment.cooling_time}m`
              : "-"}
          </td>
         
        </tr>
      </tbody>
    </table>
  </div>
)}

<div
  style={{
    marginTop: 24,
    padding: "16px 18px",
    background: "linear-gradient(90deg, #ecfeff, #f0fdfa)",
    border: "1px solid #99f6e4",
    borderLeft: "5px solid #14b8a6",
    borderRadius: 8
  }}
>
  <p
    style={{
      margin: 0,
      fontSize: 14,
      fontWeight: 700,
      color: "#0f766e",
      letterSpacing: "0.02em"
    }}
  >
    ⚠ Important Appointment Guidelines
  </p>

  <p
    style={{
      marginTop: 8,
      fontSize: 13,
      color: "#134e4a",
      lineHeight: 1.6
    }}
  >
    <b>Please Note:</b> To ensure a smooth and professional consultation experience, astrologers
    are required to strictly adhere to the appointment schedule mentioned above.
    Please initiate the consultation call only at the scheduled time and use
    the registered contact number provided below.
  </p>

  <div
    style={{
      marginTop: 10,
      padding: "10px 12px",
      background: "#ffffff",
      borderRadius: 6,
      border: "1px dashed #5eead4",
      fontSize: 13,
      fontWeight: 700,
      color: "#065f46"
    }}
  >
    📞 Contact Number:&nbsp;
    <span style={{ letterSpacing: "0.04em" }}>
      (+91)-{appointment.CustomerPhone || "-"}
    </span>
  </div>

  <p
    style={{
      marginTop: 8,
      fontSize: 12,
      color: "#475569"
    }}
  >
    <b>Important:</b> Calling outside the scheduled time window or using any
    alternate contact number to connect with the client may lead to service restrictions as per platform
    policy.
  </p>
</div>

          {/* TOPICS */}
{appointment.TopicNames && (
  <div style={{ marginTop: 20 }}>
    <p style={{ fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
      Session Topics
    </p>
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {appointment.TopicNames.split(",").map((t, i) => (
        <span
          key={i}
          style={{
            background: "#f1f5f9",
            padding: "6px 12px",
            borderRadius: 20,
            fontSize: 12,
            fontWeight: 600
          }}
        >
          {t.trim()}
        </span>
      ))}
    </div>
  </div>
)}

         <div style={{marginTop:"20px"}}>
          {categoryData?.category === "Personalised Consultation" && categoryData.data && (
  <div>
    <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
  This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 15 }}>
      <tbody>
        <tr>
          <td style={label}>Name:</td>
          <td style={value}>{categoryData.data.Named || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Gender:</td>
          <td style={value}>{categoryData.data.Gender || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Date of Birth:</td>
          <td style={value}>
            {categoryData.data.Dateofbirth
              ? new Date(categoryData.data.Dateofbirth).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Time of Birth:</td>
          <td style={value}>{categoryData.data.Timeofbirth || "-"} IST</td>
        </tr>

        <tr>
          <td style={label}>Place of Birth:</td>
          <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Booking Type:</td>
          <td style={value}>{categoryData.data.BookingType || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Calling Number:</td>
          <td style={value}>{categoryData.data.CallingNumber || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Match Making" && categoryData.data && (
  <div>
   <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
  This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Male Name:</td>
          <td style={value}>{categoryData.data.MaleName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Male Date of Birth:</td>
          <td style={value}>
            {categoryData.data.MaleDOB
              ? new Date(categoryData.data.MaleDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Male Time of Birth:</td>
          <td style={value}>
            {categoryData.data.MaleTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Male Place of Birth:</td>
          <td style={value}>{categoryData.data.MalePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Female Name:</td>
          <td style={value}>{categoryData.data.FemaleName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Female Date of Birth:</td>
          <td style={value}>
            {categoryData.data.FemaleDOB
              ? new Date(categoryData.data.FemaleDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Female Time of Birth:</td>
          <td style={value}>
            {categoryData.data.FemaleTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Female Place of Birth:</td>
          <td style={value}>{categoryData.data.FemalePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Married Life Analysis" && categoryData.data && (
  <div>
    <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
 This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Husband Name:</td>
          <td style={value}>{categoryData.data.HusbandName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Husband Date of Birth:</td>
          <td style={value}>
            {categoryData.data.HusbandDOB
              ? new Date(categoryData.data.HusbandDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Husband Time of Birth:</td>
          <td style={value}>
            {categoryData.data.HusbandTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Husband Place of Birth:</td>
          <td style={value}>{categoryData.data.HusbandPOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Wife Name:</td>
          <td style={value}>{categoryData.data.WifeName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Wife Date of Birth:</td>
          <td style={value}>
            {categoryData.data.WifeDOB
              ? new Date(categoryData.data.WifeDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Wife Time of Birth:</td>
          <td style={value}>
            {categoryData.data.WifeTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Wife Place of Birth:</td>
          <td style={value}>{categoryData.data.WifePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Business Partnership & Compatibility Analysis" &&
  Array.isArray(categoryData.data) &&
  categoryData.data.length > 0 && (
    <div>
      <div style={{ marginBottom: 12 }}>
        <p
          style={{
            fontWeight: 700,
            fontSize: 14,
            color: "#0f172a",
            marginBottom: 4,
            textTransform: "uppercase",
            letterSpacing: "0.04em"
          }}
        >
          User Submitted Information
        </p>

        <p
          style={{
            fontSize: 12,
            color: "#6b7280",
            lineHeight: "18px",
            marginBottom: 10
          }}
        >
        This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
        </p>
      </div>

      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          overflow: "hidden",
          background: "#ffffff",
          marginBottom: 20
        }}
      >
        <table
          style={{
            width: "100%",
            tableLayout: "fixed",
            borderCollapse: "collapse",
            fontSize: 13
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f1f5f9" }}>
              <th style={{ padding: 10, width: "22%", textAlign: "left" }}>
                Name
              </th>
              <th style={{ padding: 10, width: "12%", textAlign: "left" }}>
                Gender
              </th>
              <th style={{ padding: 10, width: "18%", textAlign: "left" }}>
                Date of Birth
              </th>
              <th style={{ padding: 10, width: "18%", textAlign: "left" }}>
                Time of Birth
              </th>
              <th style={{ padding: 10, width: "30%", textAlign: "left" }}>
                Place of Birth
              </th>
            </tr>
          </thead>

          <tbody>
            {categoryData.data.map((person, idx) => (
              <tr
                key={idx}
                style={{
                  borderTop: "1px solid #e5e7eb",
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa"
                }}
              >
                <td style={{ padding: 10, fontWeight: 600 }}>
                  {person.Named || "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Gender || "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Dateofbirth
                    ? new Date(person.Dateofbirth).toLocaleDateString()
                    : "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Timeofbirth || "-"} IST
                </td>

                <td
                  style={{
                    padding: 10,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    color: "#374151"
                  }}
                >
                  {person.Placeofbirth || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )}
{categoryData?.category === "Child Name Analysis" && categoryData.data && (
  <div>
   <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
  This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Gender:</td>
          <td style={value}>{categoryData.data.Gender || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Date of Birth:</td>
          <td style={value}>
            {categoryData.data.Dateofbirth
              ? new Date(categoryData.data.Dateofbirth).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Time of Birth:</td>
          <td style={value}>
            {categoryData.data.Timeofbirth || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Place of Birth:</td>
          <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 1:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option1 || "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 2:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option2 || "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 3:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option3 || "-"}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Birth Time Rectification" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Place of Birth:</td>
            <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Birth Time Window:</td>
            <td style={value}>
              {categoryData.data.BirthTimeStart || "-"} –{" "}
              {categoryData.data.BirthTimeEnd || "-"} IST
            </td>
          </tr>

          <tr>
            <td style={label}>Height Unit:</td>
            <td style={value}>{categoryData.data.HeightUnit || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Optional Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <p style={{ ...label, marginBottom: 6 }}>
            Customer Uploaded Image
          </p>
          <img
            src={categoryData.data.Image1}
            alt="Birth Time Reference"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Tarot Card Reading" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
   This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Palmistry" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
 This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Palm Images */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {[1, 2, 3, 4].map((i) => {
          const img = categoryData.data[`Image${i}`];
          if (!img) return null;

          return (
            <div key={i}>
              <img
                src={img}
                alt={`Palm Image ${i}`}
                style={{
                  maxWidth: "180px",
                  borderRadius: 8,
                  border: "1px solid #e5e7eb"
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  )}
{categoryData?.category === "Face Reading" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
  This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Face Images */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {[1, 2, 3].map((i) => {
          const img = categoryData.data[`Image${i}`];
          if (!img) return null;

          return (
            <div key={i}>
              <img
                src={img}
                alt={`Face Image ${i}`}
                style={{
                  maxWidth: "180px",
                  borderRadius: 8,
                  border: "1px solid #e5e7eb"
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  )}
{categoryData?.category === "Handwriting Analysis" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
   This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Handwriting Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <img
            src={categoryData.data.Image1}
            alt="Handwriting Sample"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Signature Analysis" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
   This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Signature Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <img
            src={categoryData.data.Image1}
            alt="Signature Sample"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Numerology" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
   This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Vastu Analysis" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
   This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Hand Made Kundali Report" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    This information was provided by the user during booking and is 
    securely shared with you to prepare for your
    consultation.
  </p>
</div>

      {/* Birth Details */}
      <p style={{ fontWeight: 600, marginBottom: 6 }}>Birth Details</p>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Time of Birth:</td>
            <td style={value}>
              {categoryData.data.Timeofbirth || "-"} IST
            </td>
          </tr>

          <tr>
            <td style={label}>Place of Birth:</td>
            <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Delivery Details */}
     {/* Delivery Details */}
<p style={{ fontWeight: 600, marginBottom: 6 }}>
  Delivery Information
</p>

<table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 15
  }}
>
  <tbody>
    <tr>
      <td style={label}>Booking Type:</td>
      <td style={value}>{categoryData.data.booking_type || "-"}</td>
    </tr>

    {!isSelfBooking && (
      <>
        <tr>
          <td style={label}>Recipient Name:</td>
          <td style={value}>{categoryData.data.fullname || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Mobile Number:</td>
          <td style={value}>{categoryData.data.mobilenumber || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Address:</td>
          <td style={value}>
            {[
              categoryData.data.flat,
              categoryData.data.area,
              categoryData.data.landmark,
              categoryData.data.city,
              categoryData.data.state,
              categoryData.data.pincode
            ]
              .filter(Boolean)
              .join(", ")}
          </td>
        </tr>
      </>
    )}
  </tbody>
</table>
    </div>
  )}
  </div>

          {/* ACTIONS */}
        <div
  style={{
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12
  }}
>
  {/* BACK */}
  <button
    onClick={() => navigate(-1)}
    style={{
      background: "#f3f4f6",
      border: "1px solid #d1d5db",
      padding: "8px 14px",
      borderRadius: 6,
      fontWeight: 600
    }}
  >
    ← Back
  </button>

  {/* MARK AS COMPLETED */}
  {appointment.Status !== "Completed" && (
    <button
      onClick={() => changeStatus("Completed")}
      style={{
        background: "#22c55e",
        border: "none",
        borderRadius: 6,
        fontSize: 13,
        padding: "10px 18px",
        fontWeight: 700,
        color: "#ffffff",
        cursor: "pointer"
      }}
    >
      Mark as Completed
    </button>
  )}
</div>

<div
  style={{
    marginTop: 16,
    padding: "14px 18px",
    background: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderLeft: "5px solid #6366f1",
    borderRadius: 8
  }}
>
  <p
    style={{
      margin: 0,
      fontSize: 14,
      fontWeight: 700,
      color: "#1e293b",
      letterSpacing: "0.02em"
    }}
  >
    Need Help? We’re Available 24/7
  </p>

  <p
    style={{
      marginTop: 8,
      fontSize: 13,
      color: "#334155",
      lineHeight: 1.6
    }}
  >
    In case of any technical issues, delayed connections, or if the client is
    unreachable at the scheduled time, please inform the Adhigyanam support team
    immediately. This helps us assist you promptly and maintain service quality.
  </p>

  <div
    style={{
      marginTop: 10,
      display: "flex",
      alignItems: "center",
      gap: 12,
      flexWrap: "wrap"
    }}
  >
    <div
      style={{
        padding: "8px 12px",
        background: "#eef2ff",
        borderRadius: 6,
        fontSize: 13,
        fontWeight: 700,
        color: "#4338ca"
      }}
    >
      📞 Support Helpline (24/7)
    </div>

    <a
      href="tel:+918960708425"
      style={{
        fontSize: 15,
        fontWeight: 800,
        color: "#1d4ed8",
        textDecoration: "none",
        letterSpacing: "0.05em"
      }}
    >
      (+91)-8960708425
    </a>
  </div>

  <p
    style={{
      marginTop: 6,
      fontSize: 12,
      color: "#64748b"
    }}
  >
    <b>Important:</b> Do not attempt repeated calls or reschedule sessions
    independently without notifying platform support.
  </p>
</div>
        </div>
      </section>
    </>
  );
};

export default AstroAppointments;